module.exports = __webpack_public_path__ + "media/customizations/simplyartavia/logo-41e49691a46613a47cc4481380c96cf5.png";